import dayjs, { Dayjs } from "~/utils/dayjs";

/**
 * Week membership for WeekPicker/WeekSelect. Weeks are Monday-start:
 * startOf/endOf("isoWeek") encodes Mon..Sun locally, with no global locale
 * state involved — a Sunday groups with the PRECEDING Monday, never the
 * following one.
 */
export const isInSameWeek = (dayA: Date, dayB: Dayjs | null | undefined) => {
  if (!dayB) {
    return false;
  }

  const startOfWeek = dayB.startOf("isoWeek");
  const endOfWeek = dayB.endOf("isoWeek");
  const dayjsDayA = dayjs(dayA);

  return (
    dayjsDayA.isSameOrAfter(startOfWeek) && dayjsDayA.isSameOrBefore(endOfWeek)
  );
};
